// extracted by mini-css-extract-plugin
export default {"cls1":"AnswersMarketingButton-cls1___d22f2792a7c263fc317","cls2":"AnswersMarketingButton-cls2__d6d57e0ec5f1d5424a7e AnswersMarketingButton-cls1___d22f2792a7c263fc317"};